<section id="header">
  <div class="container-fluid py-3">
    <div class="row header-large">
      <div class="logo">
        <img class="img-fluid" src="assets/images/header/site-logo.png" alt="site logo">
      </div>

      <div class="nav-links">
        <ul>
          <li>
            <a routerLink="/home" routerLinkActive="active">{{"HEADER.HOME" | translate}}</a>
          </li>
          <li>
            <a routerLink="/rooms" routerLinkActive="active">{{"HEADER.ROOMS" | translate}}</a>
          </li>
          <li>
            <a routerLink="/special-gifts" routerLinkActive="active">{{"HEADER.SPECIAL_GIFTS" | translate}}</a>
          </li>
          <li>
            <a routerLink="/contact-us" routerLinkActive="active">{{"HEADER.CONTACT_WITH_US" | translate}}</a>
          </li>

        </ul>
      </div>
      <div class="nav-items">
        <!-- <div class="search-sec">
          <img src="assets/images/header/magnifier.png" alt="search icon">
        </div>
        <div class="notifications-sec">
          <img src="assets/images/header/bill.png" alt="notifications icon">
        </div> -->
        <div class="lang" (click)="switchLanguage()">
          <span *ngIf="translateService.currentLang === 'en-US'">EN</span>
          <span *ngIf="translateService.currentLang === 'ar-SA'">Ar</span>
          <img src="../../../../assets/image/icons/lang.png">
        </div>

        <div class="button-login" *ngIf="!(accountService.currentUser$ | async) as user">
          <button type="submit" routerLink="/login">{{ 'LOGIN.Login-button' | translate }} </button>
        </div>
        <ng-container *ngIf="(accountService.currentUser$ |async) as user">
          <div class="profile-sec">
            <img [src]="user.user_data.image" (click)="showUserDropdownActions()" alt="profile icon">
          </div>

          @if (profileDropDownActions) {
          <div class="profile-popup-links"
            [ngClass]="currentLang == 'ar-SA' ? 'profile-popup-links-ar' : 'profile-popup-links-en'">
            <ul>
              <li>
                <img [src]="user.user_data.image" alt="profile icon">
                <span> {{user.user_data.name}}</span>
              </li>
              <li (click)="showUserDropdownActions()" routerLink="/profile">
                <span>{{"HEADER.MY_ACCOUNT" | translate}}</span>
              </li>
              <li (click)="showUserDropdownActions()" routerLink="/orders">
                <span>{{"HEADER.MY_ORDERS" | translate}}</span>
              </li>
              <li (click)="showUserDropdownActions()" routerLink="/saved-addresses">
                <span>{{"HEADER.MY_ADDRESSES" | translate}}</span>
              </li>
              <li (click)="showUserDropdownActions(); logout()">
                <span>{{"HEADER.LOGOUT" | translate}}</span>
              </li>
            </ul>
          </div>
          }
        </ng-container>



      </div>
    </div>

    <div class="row header-small">
      <nav class="navbar  navbar-dark bg-dark ">
        <div class="container-fluid">
          <div class="logo">
            <img class="img-fluid" src="assets/images/header/site-logo.png" alt="site logo">
          </div>
          <button type="button" class="toggle-btn" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar"
            aria-controls="offcanvasNavbar" aria-label="Toggle navigation">
            <img src="assets/images/header/lines.svg" alt="toggler icon">
          </button>



          <div class="offcanvas offcanvas-start" tabindex="-1" id="offcanvasNavbar"
            aria-labelledby="offcanvasNavbarLabel">
            <div class="offcanvas-header">
              <button type="button" class="btn-close btn-close-white " data-bs-dismiss="offcanvas"
                aria-label="Close"></button>
              <h5 class="offcanvas-title" id="offcanvasNavbarLabel">Refeezy</h5>
            </div>
            <div class="offcanvas-body">
              <ul class="navbar-nav justify-content-start flex-grow-1">
                <li class="nav-item">
                  <a class="nav-link active" aria-current="page" routerLink="/home" routerLinkActive="active"
                    data-bs-dismiss="offcanvas">{{"HEADER.HOME" | translate}}</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" routerLink="/rooms" routerLinkActive="active"
                    data-bs-dismiss="offcanvas">{{"HEADER.ROOMS" | translate}}</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" routerLink="/special-gifts" routerLinkActive="active"
                    data-bs-dismiss="offcanvas">{{"HEADER.SPECIAL_GIFTS" | translate}}</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" routerLink="/contact-us" routerLinkActive="active"
                    data-bs-dismiss="offcanvas">{{"HEADER.CONTACT_WITH_US" | translate}}</a>
                </li>

                <li class="nav-item">
                  <a class="nav-link" routerLink="/profile" routerLinkActive="active"
                    data-bs-dismiss="offcanvas">{{"HEADER.MY_ACCOUNT" | translate}}</a>
                </li>

                <li class="nav-item">
                  <a class="nav-link" routerLink="/orders" routerLinkActive="active"
                    data-bs-dismiss="offcanvas">{{"HEADER.MY_ORDERS" | translate}}</a>
                </li>

                <li class="nav-item">
                  <a class="nav-link" routerLink="/saved-addresses" routerLinkActive="active"
                    data-bs-dismiss="offcanvas">{{"HEADER.MY_ADDRESSES" | translate}}</a>
                </li>

                <li class="nav-item">
                  <a class="nav-link hover" data-bs-dismiss="offcanvas" (click)="logout()">{{"HEADER.LOGOUT" |
                    translate}}</a>
                </li>
              </ul>
              <div class="offcanvas-footer">
                <div class="icon">
                  <img src="assets/images/footer/footer-icons/facebook.png" alt="facebook icon">
                </div>
                <div class="icon">
                  <img src="assets/images/footer/footer-icons/twitter.png" alt="twitter icon">
                </div>
                <div class="icon">
                  <img src="assets/images/footer/footer-icons/instagram.png" alt="instagram icon">
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  </div>
</section>
